import {queryGqlApi} from "../../graphql/queryGqlApi";
import {createNotification as createNotificationGQL} from "../../graphql/mutations";
import { CrudServices } from "../../platform/services/types/ServiceDependencies";
import { UserSessionState } from "../../stores/UserSessionState";


export interface NotificationRequiredFields {
    type: string;
    userId: string;
    initiatorId: string;
    meta: string;
}

export const createNotification = (
    services: CrudServices,
    userState: UserSessionState,
    notification: NotificationRequiredFields
) => {
    return queryGqlApi(
        createNotificationGQL,
        {
            input: {
                _version: 0,
                ownerId: userState.tenantId,
                status: 'unread',
                createdAt: (new Date()).toISOString(),
                ...notification,
            }
        },
        services.dataClientService,
        services.authService,
        'main'
    )
}

